var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchingWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    rx: 36,
    fill: "#F7FBFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 210,
    width: 952,
    height: 480,
    rx: 34,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 290,
    width: 200,
    height: 320,
    rx: 30,
    fill: "#EEF7FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 290,
    width: 200,
    height: 320,
    rx: 30,
    fill: "#ECF9F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 816,
    y: 290,
    width: 200,
    height: 320,
    rx: 30,
    fill: "#FFF5E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 450H500",
    stroke: "#0F766E",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M700 450H816",
    stroke: "#0F766E",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M452 424L500 450L452 476",
    stroke: "#0F766E",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M768 424L816 450L768 476",
    stroke: "#0F766E",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232 356H334",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M220 402H346",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M220 444H318",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 520,
    r: 44,
    stroke: "#0F766E",
    strokeWidth: 12
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M548 356H652",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M536 402H664",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M600 480L630 520L670 462",
    stroke: "#0F766E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M864 356H968",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M852 402H980",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M884 502H952",
    stroke: "#F59E0B",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M916 468V536",
    stroke: "#F59E0B",
    strokeWidth: 18,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchingWorkflow);
export default __webpack_public_path__ + "static/media/matching-workflow.d5b55131a23518e4b791056601323b4c.svg";
export { ForwardRef as ReactComponent };